import ClientPortal from '../../../plugins/axios'

export default {
    isAuthorized() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin`)
    },
    /**
     * UTILS
     */
    fetchPortalApproval(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/utils/fetch-portal-approval`, { params: data })
    },
    cancelPortalApproval(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/utils/cancel-portal-approval`, data )
    },
    listCancelledPortalApprovals(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/utils/list-cancelled-portal-approvals`, { params: data })
    },

    /**
     * ACU
     */
    listCancelledApproval(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/list-cancelled-approval`, { params: data })
    },
    cancelAcuApproval(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/cancel-acu-approval`, data)
    },
    extendLetter(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/extend-letter`, data)
    },
    generateLetterReport(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/generate-letter-report`, { params: data })
    },
    acuActiveList(config = {}) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/acu-active-list`, config)
    },
    toggleAcuStatus(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/toggle-acu-status`, data)
    },
    toggleAcuProgress(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/toggle-acu-progress`, data)
    },
    getMsuRates(data) {
        const params = new URLSearchParams(data).toString()
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/get-msu-rates?${params}`)
    },
    editMsuRates(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/edit-msu-rates`, data)
    },
    deleteMsuRates(data) {
        const params = new URLSearchParams(data).toString()
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-msu-rates?${params}`)
    },
    addMsuRates(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/add-msu-rates`, data)
    },
    viewAccountCoverages(data) {
        const params = new URLSearchParams(data).toString()
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/view-account-coverages?${params}`)
    },
    editAccountCoverage(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/edit-account-coverage`, data)
    },
    deleteAccountCoverage(data) {
        const params = new URLSearchParams(data).toString()
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-account-coverage?${params}`)
    },
    addAccountCoverage(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/add-account-coverage`, data)
    },
    approveAcuStatus(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/approve-acu-status`, data)
    },
    approveAccountCoverage(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/approve-account-coverage`, data)
    },
    fetchAcuProviders(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-providers`, data)
    },
    fetchAcuApprovalLogs(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-approval-logs`, { params: data })
    },
    fetchAcuDisapprovalLogs(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-disapproval-logs`, { params: data })
    },
    fetchAcuMemberSummary(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-member-summary`, { params: data })
    },
    fetchAcuAccountSummary(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-account-summary`, { params: data })
    },
    fetchAcuProviderLoginList(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-provider-login-list`, { params: data })
    },
    showAcuAtGlance(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/show-acu-at-glance`, { params: data })
    },
    generateAcuReport(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/generate-acu-report`, { params: data })
    },
    downloadAcuApproval(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/download-acu-approval`, { params: data })
    },
    fetchAcuApproval(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-acu-approval`, { params: data })
    },
    revalidateAcuApproval(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/revalidate-acu-approval`, data)
    },
    generateQualifiedList(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/generate-qualified-list`, { params: data })
    },
    validateMembersFromExcel(data) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/admin/acu/qualify-members-via-excel`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
    },
    viewAccountClinics(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/view-account-clinics`, { params: data })
    },
    insertAccountClinic(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/insert-account-clinic`, data)
    },
    approveAccountClinic(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/approve-account-clinic`, data)
    },
    deleteAccountClinic(data) {
        const params = new URLSearchParams(data).toString()
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-account-clinic?${params}`)
    },
    getStatusProvision(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/get-status-provision`, { params: data })
    },
    generateEndorsementConfirmation(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/generate-endorsement-confirmation`, data)
    },
    listEndorsementConfirmation() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/list-endorsement-confirmation`)
    },
    signEndorsementConfirmation(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/sign-endorsement-confirmation`, data)
    },
    viewEndorsementConfirmation(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/view-endorsement-confirmation`, { params: data })
    },
    deleteEndorsementConfirmation(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-endorsement-confirmation`, { params: data })
    },
    deleteMemberFromEndorsementConfirmation(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/remove-member-from-endorsement-confirmation`, { params: data })
    },
    suggestAcuDiagnostics () {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/list-acu-diagnostic-suggestions`)
    },
    getPackageDiagnostics(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/get-package-diagnostics`, { params: data })
    },
    editDiagnosticPackage(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/edit-diagnostic-package`, data)
    },
    deletePackageDiagnostic(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-package-diagnostic`, { params: data })
    },
    addDiagnosticToPackage(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/add-diagnostic-to-package`, data)
    },
    suggestEndorsementRecipient(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/suggest-endorsement-recipient`, { params: data })
    },
    editMsuGroupName(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/edit-msu-group-name`, data)
    },
    listMsuGroups() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/list-msu-groups`)
    },
    viewMsuGroup(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/view-msu-group`, { params: data })
    },
    insertToMsuGroup(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/insert-to-msu-group`, data)
    },
    deleteMsuFromGroup(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-msu-from-group`, { params: data })
    },
    deleteMsuGroup(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-msu-group`, { params: data })
    },
    createMsuGroup(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/create-msu-group`, data)
    },
    viewProviderAcuInfo(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/view-provider-acu-info`, { params: data })
    },
    editProviderAcuInfo(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/acu/edit-provider-acu-info`, data)
    },
    addProviderAcuInfo(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/add-provider-acu-info`, data)
    },
    deleteProviderAcuInfo(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/delete-provider-acu-info`, { params: data })
    },
    fetchMembersOfScopedBenefit(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/fetch-members-of-scoped-benefit`, { params: data })
    },
    insertMemberToScopedBenefit(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/insert-member-to-scoped-benefit`, data)
    },
    removeMemberFromScopedBenefit(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/remove-member-from-scoped-benefit`, { params: data })
    },
    linkDiagRate(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/acu/link-diag-rate`, data)
    },
    unlinkDiagRate(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/acu/unlink-diag-rate`, { params: data })
    },
    viewLinkedDiagRate(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/acu/view-linked-diag-rate`, { params: data })
    },


    /**
     * CLAIMS
     */
    downloadLedgerClaims(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/claims/download-ledger`, data)
    },
    fetchListLedgers(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/claims/fetch-list-ledgers`, payload)
    },
    viewLedger(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/claims/view-ledger`, data)
    },
    fetchListProviderClaims() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/claims/fetch-msu-list`)
    },

    /**
     * MEMBER
     */
    downloadApprovalMemb(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/download-approval`, data)
    },
    downloadReportMemb(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/download-report`, data)
    },
    showMemberLoginList(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/show-member-login-list`, data)
    },
    showMemberApprovalLogs(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/show-member-approval-logs`, data)
    },
    showMemberDisapprovalLogs(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/show-member-disapproval-logs`, data)
    },
    showMemberSummaryTable(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/show-member-summary-table`, data)
    },
    showAccountSummaryTable(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/show-account-summary-table`, data)
    },
    showMemberAtGlance(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/member/show-at-glance`, data)
    },

    /**
     * PROVIDER
     */
    editProviderAccount(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/provider/edit-provider-account`, data)
    },
    disableProviderAccount(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/provider/disable-provider-account`, { data, withCredentials: true })
    },
    downloadApprovalProvider(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/download-approval`, data)
    },
    downloadReport(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/download-report`, data)
    },
    showProviderLoginList(data) {
        const params = new URLSearchParams(data).toString()
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/provider/show-provider-login-list?${params}`)
    },
    showProviderAtGlance(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/show-provider-at-glance`, data)
    },
    showProviderSummary(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/show-provider-summary`, data)
    },
    showProviderDisapprovalLogs(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/show-provider-disapproval-logs`, data)
    },
    showProviderApprovalLogs(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/show-provider-approval-logs`, data)
    },
    showProviderValidationLogs(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/show-provider-validate-logs`, data)
    },
    showProviderLinks(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/show-provider-links`, data)
    },
    fetchProviders(data) {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/provider/fetch-providers`, data)
    },
    unlinkProviders(data) {
        return ClientPortal.delete(`${process.env.VUE_APP_API}/admin/provider/unlink-providers`, { data, withCredentials: true })
    },
    linkProviders(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/link-providers`, data)
    },
    signupProvider(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/provider/signup-provider`, data)
    },

    /**
     * LOGIN
     */
    recoverPasswordAdmin(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/login/recover-password`, data, { withCredentials: true })
    },
    forgotPasswordAdmin(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/login/forgot-password`, data)
    },
    changePasswordAdmin(data) {
        return ClientPortal.patch(`${process.env.VUE_APP_API}/admin/login/change-password`, data, { withCredentials: true })
    },
    getUserInfo() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/admin/login/get-user-info`)
    },
    login(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/login/`, data)
    },

    /**
     * SIGNUP
     */
    adminSignup(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/signup/admin-signup`, data)
    },
    adminVerifySignup(data) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/admin/signup/admin-verify-signup`, data)
    },
    async getCsrfToken() {
        // console.log("getcsrf default store api signupapi")
        const csrf = await ClientPortal.get(`${process.env.VUE_APP_API}/signup/getCsrfToken`)
        // console.log('csrf log in getCsrfToken: ', csrf);
        return csrf
    }
}
